import api from '../../../../api/client';

export const SEARCH_FIELD_OPTIONS = [
  { value: 'Name', label: 'Employee Name' },
  { value: 'EmpId', label: 'Emp ID' },
  { value: 'PayHead', label: 'Pay Head' },
];

export const STATUS_OPTIONS = [
  { value: 'All', label: 'All Status' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];

export const TOOLS_OPTIONS = [
  { key: 'print', label: 'Print Report', icon: 'print' },
  { key: 'export_excel', label: 'Export Excel', icon: 'description' },
  { key: 'export_pdf', label: 'Export PDF', icon: 'picture_as_pdf' },
];

export function formatDateDisplay(dtStr) {
  if (!dtStr) return '';
  const d = new Date(dtStr);
  if (isNaN(d.getTime())) return dtStr;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function mapBackendToFrontend(item) {
  if (!item) return null;
  return {
    id: item.id || item.ID,
    employee: item.emp_name || (item.emp_id ? `Employee #${item.emp_id}` : ''),
    employeeId: item.emp_code || (item.emp_id ? `EMP-${item.emp_id}` : ''),
    emp_id: item.emp_id || item.EmpID,
    vno: item.vno ? `DED-${String(item.vno).padStart(3, '0')}` : '-',
    vnoRaw: item.vno,
    vDate: item.v_date ? String(item.v_date).split('T')[0] : (item.vDate ? String(item.vDate).split('T')[0] : ''),
    vDateDisplay: formatDateDisplay(item.v_date || item.vDate),
    payHead: item.pay_head_name || '',
    payHeadAlias: item.pay_head_alias || '',
    pay_head_id: item.pay_head_id || item.PayHeadID,
    amount: Number(item.amount !== undefined ? item.amount : (item.Amount || 0)),
    status: (item.is_deleted || item.Isdeleted) ? 'Inactive' : 'Active',
  };
}

export const deductionsApi = {
  getDeductionOptions: async () => {
    const { data } = await api.get('/payroll/emp-deductions/options');
    return {
      employees: (data?.employees || []).map((e) => ({
        value: e.id,
        label: `${e.name}${e.code ? ` (${e.code})` : ''}`,
        raw: e,
      })),
      payHeads: (data?.pay_heads || []).map((p) => ({
        value: p.id,
        label: `${p.name}${p.alias ? ` (${p.alias})` : ''}`,
        raw: p,
      })),
    };
  },

  getDeductions: async (filters = {}) => {
    const params = {
      emp_id: filters.emp_id || filters.empId || undefined,
      from_emp_id: filters.from_emp_id || filters.fromEmpId || undefined,
      till_emp_id: filters.till_emp_id || filters.tillEmpId || undefined,
      pay_head_id: filters.pay_head_id || filters.payHeadId || filters.payHeadFilter || undefined,
      from_date: filters.fromDate || filters.from_date || undefined,
      to_date: filters.toDate || filters.to_date || undefined,
      from_amount: filters.fromAmount ? Number(filters.fromAmount) : (filters.amount ? Number(filters.amount) : undefined),
      to_amount: filters.toAmount ? Number(filters.toAmount) : (filters.tillAmount ? Number(filters.tillAmount) : undefined),
      employee: filters.employee || filters.employeeFilter || filters.searchText || undefined,
      search: filters.search || undefined,
      page: filters.page || 1,
      page_size: filters.pageSize || 25,
    };

    const { data } = await api.get('/payroll/emp-deductions/', { params });
    const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
    let list = items.map(mapBackendToFrontend);

    if (filters.status && filters.status !== 'All') {
      list = list.filter((r) => r.status === filters.status);
    }

    return {
      items: list,
      total: data?.total !== undefined ? data.total : list.length,
      page: data?.page || params.page,
      pageSize: data?.page_size || params.page_size,
      totalPages: data?.total_pages || 1,
    };
  },

  getDeductionsReport: async (filters = {}) => {
    const params = {
      emp_id: filters.emp_id || filters.empId || undefined,
      from_emp_id: filters.from_emp_id || filters.fromEmpId || undefined,
      till_emp_id: filters.till_emp_id || filters.tillEmpId || undefined,
      pay_head_id: filters.pay_head_id || filters.payHeadId || filters.payHeadFilter || undefined,
      from_date: filters.fromDate || filters.from_date || undefined,
      to_date: filters.toDate || filters.to_date || undefined,
      from_amount: filters.fromAmount ? Number(filters.fromAmount) : (filters.amount ? Number(filters.amount) : undefined),
      to_amount: filters.toAmount ? Number(filters.toAmount) : (filters.tillAmount ? Number(filters.tillAmount) : undefined),
      employee: filters.employee || filters.employeeFilter || filters.searchText || undefined,
    };
    const { data } = await api.get('/payroll/emp-deductions/report', { params });
    return data;
  },


  getDeductionById: async (id) => {
    const { data } = await api.get(`/payroll/emp-deductions/${id}`);
    return mapBackendToFrontend(data);
  },

  createDeduction: async (payload) => {
    const body = {
      emp_id: Number(payload.emp_id),
      v_date: payload.v_date || payload.date || payload.vDate,
      pay_head_id: Number(payload.pay_head_id),
      amount: Number(payload.amount),
    };
    const { data } = await api.post('/payroll/emp-deductions/', body);
    return data;
  },

  updateDeduction: async (id, payload) => {
    const body = {
      emp_id: payload.emp_id ? Number(payload.emp_id) : undefined,
      v_date: payload.v_date || payload.date || payload.vDate || undefined,
      pay_head_id: payload.pay_head_id ? Number(payload.pay_head_id) : undefined,
      amount: payload.amount !== undefined ? Number(payload.amount) : undefined,
    };
    const { data } = await api.put(`/payroll/emp-deductions/${id}`, body);
    return data;
  },

  deleteDeduction: async (id) => {
    const { data } = await api.delete(`/payroll/emp-deductions/${id}`);
    return data;
  },
};
